module.exports = __webpack_public_path__ + "static/media/starYellow.2d15ec30.png";